module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/_library.js
// module id = 70
// module chunks = 0